export default __webpack_public_path__ + "static/media/Logo_Customer.86c1d346.svg";